module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invite-error"
  }, [_c('Icon'), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.text1))]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.text2))]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.text3))]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.text4))]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.text5))])]), _vm._v(" "), _c('Buttons', {
    staticStyle: {
      "width": "200px",
      "margin-top": "50px"
    },
    attrs: {
      "type": 'tosignup'
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-087ec91e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/invite/Inviteerror.vue
// module id = 759
// module chunks = 1